import { getAllData } from "apis/customApiHandler";
import useDebounce from "hooks/useDebounce";
import { useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { Button, Input, Select } from "styled";
import { TH } from "styled/table";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import Add from "./Add";
import ViewList from "./ViewList";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import Spinner from "components/Spinner";

const Index = () => {
  const [showAddmodel, setShowAddmodel] = useState(false);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const currentUser = useSelector((state) => state.user.currentUser);
  const debouncedValue = useDebounce(search, 1000);
  const [page, setPage] = useState(1);
  const { data, isLoading } = useQuery(
    ["product-master", debouncedValue && debouncedValue, page, category],
    () =>
      getAllData("/product-master", {
        searchQuery: debouncedValue,
        limit: 150,
        page: page,
        category: category !== "ALL" ? category : "",
      }),
  );

  return (
    <div>
      <div className="m-10">
        <div className="mt-8 flex justify-start gap-6 items-end flex-wrap lg:flex-nowrap">
          <div className="relative w-full">
            <Input
              type="search"
              placeholder="Search Here"
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
            />
          </div>
          <label className="w-[200px]">
            Category
            <Select
              name="contractType"
              className="mt-2"
              value={category}
              onChange={(e) => {
                setCategory(e.target.value);
                setPage(1);
              }}
            >
              <option value={""}>All</option>
              <option value="RADIAL">RADIAL</option>
              <option value="BIAS">BIAS</option>
            </Select>
          </label>
          <Button
            className="!px-8 disabled:bg-gray-400"
            onClick={() => setShowAddmodel(true)}
            bgPrimary
            disabled={
              !checkPermission(
                [
                  permissions.manage_stencil_menu,
                  permissions.manage_masters,
                  permissions.manage_product_master,
                ],
                currentUser,
              )
            }
          >
            Add
          </Button>
        </div>
      </div>
      <div className="flex flex-col m-2 lg:m-10">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-200 justify-center">
                <thead className="bg-gray-50">
                  <tr>
                    <TH scope="col">S.N.</TH>
                    <TH scope="col">Company</TH>
                    <TH scope="col">Category</TH>
                    <TH scope="col">Tyre Size</TH>
                    <TH scope="col">Material Number</TH>
                    <TH scope="col">Material Description</TH>
                    <TH scope="col">Original NSD</TH>
                    {/* <TH scope="col">Brand</TH> */}
                    <TH scope="col">Created At</TH>
                    <TH scope="col">Actions</TH>
                  </tr>
                </thead>

                {isLoading ? (
                  <Spinner />
                ) : (
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data?.data && data.data.length > 0 ? (
                      data.data.map((d, index) => (
                        <ViewList
                          data={d}
                          key={d._id}
                          index={index}
                          page={page}
                        />
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={9}
                          className="text-center py-8 text-gray-500 text-sm"
                        >
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </div>
        {data && data.paginate && data.paginate.totalPage > 0 && (
          <div className="container mx-auto flex justify-center items-center gap-2 py-5">
            <Button
              onClick={() => {
                setPage((p) => Math.max(p - 1, 1));
              }}
              disabled={page === 1}
              className="disabled:pointer-events-none disabled:opacity-70 px-0 "
              primary
            >
              <div className="flex gap-1 items-center">
                <IoMdArrowBack />
                Prev Page
              </div>
            </Button>
            <span className="text-gray-600 px-4">{`showing: ${
              (page - 1) * 150 + 1
            } - ${Math.min(data?.paginate?.totalData, page * 150)} of ${
              data.paginate.totalData
            }`}</span>

            {data.paginate.totalData > page * 150 && (
              <Button
                onClick={() => {
                  setPage((p) => Math.min(p + 1, data?.paginate?.totalPage));
                }}
                disabled={page === data?.paginate?.totalPage}
                className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                primary
              >
                <div className="flex gap-1 items-center">
                  Next Page
                  <IoMdArrowForward />
                </div>
              </Button>
            )}
          </div>
        )}
      </div>
      {showAddmodel && <Add handleClick={() => setShowAddmodel(false)} />}
    </div>
  );
};

export default Index;
